export default "__VITE_ASSET__BoktK7vk__"